import axios from "axios";
import useAuthStore from "../store/authStore";
import getBaseUrl from "./getBaseUrl";

const API = axios.create({ baseURL: getBaseUrl().baseUrl });

API.interceptors.request.use((config) => {
  const { token } = useAuthStore.getState();

  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.reload(false);
    }
    return Promise.reject(error);
  }
);

export default API;
